declare const StudioBuilderCSS: string | undefined;

export function InjectBuilderCSS(parent: HTMLElement) {
  if (typeof StudioBuilderCSS !== 'string') return;

  const css = StudioBuilderCSS;

  const style = document.createElement('style');
  style.type = 'text/css';
  style.id = 'StudioBuilderCSS';
  parent.appendChild(style);

  if ((style as any).styleSheet) {
    (style as any).styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
